import React, { useState, useEffect } from 'react';
import BusinessCalendar from '../../components/BusinessCalendar/BusinessCalendar';
import "./CalendarTabs.css";

const CalendarTabs = ({ 
  calendars = [], 
  userId, 
  userBusinessId,
  businessData,
  onCalendarChange,
  defaultActiveId = null,
  showStats = true,
  showSettings = true
}) => {
  const [activeCalendarId, setActiveCalendarId] = useState(defaultActiveId);

  // Set initial active calendar
  useEffect(() => {
    if (calendars.length > 0) {
      if (defaultActiveId && calendars.find(c => c.id === defaultActiveId)) {
        setActiveCalendarId(defaultActiveId);
      } else {
        // Find default calendar or use first
        const defaultCalendar = calendars.find(c => c.isDefault) || calendars[0];
        setActiveCalendarId(defaultCalendar?.id);
      }
    }
  }, [calendars, defaultActiveId]);

  const handleTabClick = (calendarId) => {
    setActiveCalendarId(calendarId);
    if (onCalendarChange) {
      onCalendarChange(calendarId);
    }
  };



  if (!calendars || calendars.length === 0) {
    return (
      <div className="calendar-tabs-empty">
        <div className="empty-state">
          <div className="empty-icon">
            <i className="bi bi-calendar-x"></i>
          </div>
          <h5 className='poppin'>No Calendars Available</h5>
          <p className="text-muted">Please add calendars in your business settings.</p>
          <button className="btn btn-outline-primary btn-sm">
            <i className="bi bi-plus-circle me-1"></i>
            Add Calendar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="calendar-tabs-component mt-5">
      {/* Tabs Navigation */}
      <div className="calendar-tabs-nav">
        <div className="nav-scroll-container">
          {calendars.map((calendar) => (
            <button
              key={calendar.id}
              className={`calendar-tab ${activeCalendarId === calendar.id ? 'active' : ''}`}
              onClick={() => handleTabClick(calendar.id)}
              title={calendar.description}
            >
              <div className="tab-content">
                <span 
                  className="tab-color-indicator"
                  style={{ backgroundColor: calendar.colorHex || '#3B82F6' }}
                />
                <span className="tab-label">{calendar.calendar_name}</span>
                
                {calendar.isDefault && (
                  <span className="tab-badge default">
                    <i className="bi bi-star-fill"></i>
                  </span>
                )}
                
                {!calendar.isActive && (
                  <span className="tab-badge inactive">
                    <i className="bi bi-pause-circle"></i>
                  </span>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Active Calendar Content */}
      <div className="calendar-tabs-content">
        {calendars.map((calendar) => (
          activeCalendarId === calendar.id && (
            <div key={calendar.id} className="calendar-tab-pane">
              {/* Calendar Header */}
              <div className="calendar-header">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <h4 className="calendar-title">
                      <span 
                        className="calendar-color-badge me-2"
                        style={{ backgroundColor: calendar.colorHex || '#3B82F6' }}
                      />
                      {calendar.calendar_name} - Booking Calendar
                            {/* <pre>{JSON.stringify(calendar)}</pre> */}

                      
                      <span className="calendar-status-badges">
                        {calendar.is_default && (
                          <span className="badge bg-primary ms-2">
                            <i className="bi bi-star-fill me-1"></i>
                            Default
                          </span>
                        )}
                        {!calendar.is_active && (
                          <span className="badge bg-warning ms-2">
                            <i className="bi bi-pause-circle me-1"></i>
                            Inactive
                          </span>
                        )}
                      </span>
                    </h4>
                  </div>

                </div>

              </div>

              {/* Calendar Component */}
              <div className="calendar-component-wrapper">
                <BusinessCalendar 
                  clientId={userId}
                  calendarId={calendar.id}
                  colorData={calendar.colorHex || '#3B82F6'}
                  calendarName={calendar.name}
                  calendarSettings={{
                    slotDuration: calendar.slotDurationMinutes || 30,
                    bufferBefore: calendar.bufferBeforeMinutes || 15,
                    bufferAfter: calendar.bufferAfterMinutes || 15,
                    maxConcurrent: calendar.maxConcurrentBookings || 1
                  }}
                  businessData={businessData}
                />
              </div>
            </div>
          )
        ))}
      </div>
    </div>
  );
};

export default CalendarTabs;